<template>
  <div>
    <floor1/>
    <floor2/>
    <floor3_new />
    <floor6/>
    <floor5/>
  </div>
</template>
<script>
import  floor1  from "./floor1.vue"
import  floor2  from "./floor2.vue"
import floor3_new from "./floor3_new.vue"
import  floor5  from "./floor5.vue"
import  floor6  from "./floor6.vue"
import metaInfo from "@/common/util/metaInfo"
export default {
  name: "Index",
  metaInfo: metaInfo.Index,
  components: {
    floor1,
    floor2,
    floor3_new,
    floor5,
    floor6,
  },
  data() {
    return {

    };
  },

  methods: {

  },
};
</script>

<style>

</style>
